{
  "ResourcePortalBookingSidebar": {
    "booking": "Booking",
    "dates": "Dates",
    "tasks": "Tasks",
    "note": "Note",
    "noNoteLeft": "No note left",
    "files": "Files",
    "comingSoon": "Coming Soon"
  },
  "ResourcePortalMenu": {
    "portalFor": "portal for",
    "routes": {
      "calendar": "Calendar",
      "bookings": "Bookings",
      "details": "Details"
    }
  },
  "CalendarRoute": {
    "anErrorOccurred": "An error occurred",
    "leaveWithoutSubmittingChanges": "Are you sure you want to leave without submitting your changes?",
    "shareAvailability": "{{resourceFullName}}, share your availability with {{companyUserFirstName}} at {{companyName}}",
    "successShareTitle": "Availabilities Sent",
    "successShare": "{{companyUserFirstName}} at {{companyName}} will be notified on your upcoming availability",
    "gotItThanks": "Got it, thanks",
    "availabilityBetween": "{{companyUserFirstName}} wants to know your availability between {{startDate}} - {{endDate}}.",
    "shareInstruction": "Share your availability by selecting the statuses below to fill the calendar.",
    "submitCalendar": "Submit Calendar",
    "today": "Today",
    "availabilityAssignedCannotEdit": "This availability has productions assigned and cannot be edited",
    "allDay": "All day",
    "perDay": "Available for {{hours}}h{{mins}} / day",
    "daily": " daily",
    "unavailable": "Unavailable",
    "mobileHint": {
      "title": "Add availability",
      "intro": "Use the calendar to manage availability periods:",
      "items": {
        "selectStatus": "Choose Available or Unavailable, then hold and drag over dates to add a period.",
        "adjustHours": "Tap an added period to set all day, hours per day, or specific times.",
        "moveOrResize": "Drag an existing period to move it, or drag its edge to extend or shorten the date range."
      },
      "open": "Show availability help",
      "dismiss": "Got it"
    },
    "status": {
      "AVAILABLE": "Available",
      "UNAVAILABLE": "Unavailable"
    },
    "tooltip": {
      "actionView": "CLICK TO VIEW",
      "actionEdit": "CLICK TO EDIT",
      "cannotEdit": "Cannot edit",
      "notEditable": "NOT EDITABLE",
      "availableAllDay": "Available all day",
      "availableForHours": "Available for {{hours}} hours daily",
      "availableSpecificHours": "Available {{start}} - {{end}} daily",
      "deleteAvailability": "Delete availability"
    },
    "cannotEditModal": {
      "title": "Cannot Edit Status",
      "message": "Only the booking owner can edit this status. If you need this status changed, please contact the person coordinating your booking.",
      "dismiss": "Dismiss"
    },
    "availabilityEditDialog": {
      "title": "Configure Availability",
      "description": "Editing availability for",
      "saveChanges": "Save Changes"
    }
  },
  "BookingsRoute": {
    "comingSoon": "Coming Soon",
    "description": "View your active and previous bookings with {{companyName}}",
    "details": "Keep track of confirmed bookings and follow statuses across invoice and payments."
  },
  "ContactDetailsRoute": {
    "comingSoon": "Coming Soon",
    "description": "Tell {{companyName}} when your contact details have changed",
    "details": "Submit new contact information and perform other useful actions through this portal."
  }
}
